<template>
    <div class='flex h-full ds-nazn-house-view' style='overflow: auto'>
        <div class='flex h-full tep-tree__container'>
            <ai-tree-list-edit
                ref='treeRef'
                :meta="treeMeta"
                :to-remove-toolbar-items-names="removeTreeToolbarBtns"
                @cell-click='onTreeCellClick'
                @insert-save="insertSave"
                @toolbar-button-click="onToolbarClickTree"
                @user-data-changed='onUserDataChanged'
                @changesSavedSuccessfully="changesSavedSuccessfully"
                @refreshEnd="onRefreshEnd"
             >
            </ai-tree-list-edit>
        </div>
        <div class='h-full flex flex-col w-full'>
            <div class="tep-header_block">
                <div class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-label'>Наименование</div>
                    <div style="width: 600px">
                        <ai-text-box
                            :value='nameTree'
                            @input='(data) => onTreeDataChange("name", data.newText)'
                        ></ai-text-box>
                    </div>
                </div>
                <div  class='tep-header-item w-full flex dx-field'>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Краткое наименование</div>
                        <div  style="width: 300px">
                            <ai-text-box
                                :value='nameShortTree'
                                @input='(data) => onTreeDataChange("name2", data.newText)'
                            ></ai-text-box>
                        </div>
                    </div>
                    <div class='tep-header-item flex'>
                        <div class='tep-header-label'>Усредненная температура</div>
                        <div  style="width: 140px">
                            <ai-number-box
                                :value='tempTree'
                                @input='(data) => onTreeDataChange("tvr", data.newText)'
                            ></ai-number-box>
                        </div>
                    </div>
                </div>
            </div>
            <div class='text-xl tep-grid-name'>Удельные тепловые характеристики</div>
            <ai-grid-edit
                ref='gridRef'
                :meta='gridMeta'
                :args='gridArgs'
                :to-remove-toolbar-items-names='removeGridToolbarBtns'
            ></ai-grid-edit>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ds-nazn-house-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import AiTextBox from '@/components/ai-text-box.vue';
import AiNumberBox from '@/components/ai-number-box.vue';

const treeRef = ref(null);
const dataTree = ref(null);
const btnToolbar = ref(null);
const gridRef = ref(null);
const gridArgs = ref();
const selectedNsiKod = ref(null);
const defaultSaveArgs = ref({kodnaznteplo: -1, dep: +getCookie('dep')});
const nameTree = ref(null);
const nameShortTree = ref(null);
const tempTree = ref(null);

onMounted(async() => {
    await treeRef.value?.setDataSource();
    await onStartSelectTree();
});

const onStartSelectTree = async(keySelect = null) => {
    let keySelectTreeFocus = keySelect;
    dataTree.value = await treeRef.value?.getTreeListDataSource();
    if(!keySelectTreeFocus) {
        keySelectTreeFocus = dataTree.value?.length ? dataTree.value[0].kodnaznteplo : null;
    }
    selectedNsiKod.value = keySelectTreeFocus;
    await treeRef.value?.treeListInstance.option('focusedRowKey', keySelectTreeFocus);
    defaultSaveArgs.value.kodnaznteplo = keySelectTreeFocus;
    await getGridArgs(keySelectTreeFocus);
    await getNameFields();
};

const getNameFields = async () => {
    nameTree.value = await treeValue('name');
    nameShortTree.value = await treeValue('name2');
    tempTree.value = await treeValue('tvr');
};

const clearNameFields = () => {
    nameTree.value = null;
    nameShortTree.value = null;
    tempTree.value = null;
}

const treeValue =  (field) => {
    const rowData = dataTree.value?.find(el => el.kodnaznteplo === selectedNsiKod.value);
    return rowData ? rowData[field] : null
};

const getGridArgs = async (key) => {
    defaultSaveArgs.value.kodnaznteplo = key;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    await  setTimeout(async () =>{
        await gridRef.value?.setDataSource();
        const dataGrid = await gridRef.value?.getGridDataSource();
        const keySelectGridFocus = dataGrid?.length ? dataGrid[0].kod : null;
        await gridRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    }, 100);
};

const onTreeCellClick = async (event, newEl = false) => {
    const check = await checkGrid();
    if(!check) return;
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    if( !buttonsRefs.value['isSaveButtonDisabled'] && !newEl && selectedNsiKod.value !== event.key) {
        const checkT = await checkTree();
        if(!checkT) return;
    }

    selectedNsiKod.value = event.key;
    await getNameFields();
    await buttonsStateChangeDisabled(false)

    if(selectedNsiKod.value !== defaultSaveArgs.value.kodnaznteplo) {
        await getGridArgs(selectedNsiKod.value);
    }
};

const checkGrid = async () => {
    await gridRef.value.gridInstance.clearSelection();
    const canClose = await gridRef.value?.checkBeforeClose();
    return canClose;
};

const checkTree = async () => {
    await treeRef.value.treeListInstance.clearSelection();
    let canClose = await treeRef.value?.checkBeforeClose();
    return canClose;
};

const onTreeDataChange = async (field, textData) => {
    const instance = await treeRef.value?.treeListInstance;
    if (!instance) return;
    const focusedRowKey = await instance.option('focusedRowKey');
    if (focusedRowKey != null) {
        const focusedRowIndex = instance.getRowIndexByKey(focusedRowKey);
        if(field === 'tvr' && textData === 0) textData = null;
        instance.cellValue(focusedRowIndex, field, textData);
        await buttonsStateChangeDisabled(true);
    }
};

const buttonsStateChangeDisabled = async (status) => {
    const buttonsRefs = await treeRef.value?.getButtonsRefs();
    buttonsRefs.value['isAddChildButtonDisabled'] = status;
    buttonsRefs.value['isAddSiblingButtonDisabled'] = status;
    buttonsRefs.value['isDeleteButtonDisabled'] = status;
};

const onToolbarClickTree = async(event) => {
    const name = event?.item?.component?.name;
    btnToolbar.value = name;
    const check = await checkGrid();
    if(!check) return;
};

const changesSavedSuccessfully = async() => {
    if(btnToolbar.value === 'delete') {
        await onStartSelectTree();
    }
    btnToolbar.value = null;
}

const insertSave = async (insert) => {
    if(insert?.responses?.length) {
        await buttonsStateChangeDisabled(false);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        if(insert?.responses[0].id) {
            selectedNsiKod.value = insert?.responses[0].id;
            await onStartSelectTree(selectedNsiKod.value);
        }
    }
};

const onUserDataChanged = async (userData) => {
    const insertData = userData.treeListChanges?.filter(el => el.type === 'insert') ?? [];
    if(insertData?.length) {
        const itemNew = insertData[0];
        await onTreeCellClick(itemNew, true);
        dataTree.value = await treeRef.value?.getTreeListDataSource();
        await treeRef.value?.treeListInstance.option('focusedRowKey', itemNew.key);
    }
};

const onRefreshEnd = async () => {
    if(btnToolbar.value === 'refresh') {
        clearNameFields();
        await treeRef.value?.setFocusdRow(selectedNsiKod.value);
        await onStartSelectTree(selectedNsiKod.value);
    }
}

const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser', 'cut', 'put'];
const removeGridToolbarBtns = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy'];
const treeMeta = {
    "keyExpr": "kodnaznteplo",
    "columns": [
        {
            "name": "kodnaznteplo",
            "caption": "kodnaznteplo",
            "dataField": "kodnaznteplo",
            "allowEditing": false,
            "width": 250,
            "index": 1,
            "visible": false
        },
        {
            "name": "name",
            "caption": "Наименование",
            "dataField": "name",
            "allowEditing": false,
            "width": '100%',
            "index": 2,
            "visible": true
        },
        {
            "name": "name2",
            "caption": "Краткое наименование",
            "dataField": "name2",
            "allowEditing": false,
            "width": 250,
            "index": 3,
            "visible": false
        },
        {
            "name": "kod_parent",
            "caption": "kod_parent",
            "dataField": "kod_parent",
            "allowEditing": false,
            "width": 250,
            "index": 4,
            "visible": false
        },
        {
            "name": "tvr",
            "caption": "tvr",
            "dataField": "tvr",
            "allowEditing": false,
            "width": 250,
            "index": 5,
            "visible": false
        },
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/ds-nazn-house-tree/select/get",
        "save": "tep-nsi./tep-nsi/ds-nazn-house-tree/save/set"
    },
    "viewId": " view-ds-nazn-house-tree",
    "parentIdExpr": "kod_parent",
    'findTool': 'filter',
    'selectButtonMode': 'single',
    'selectionMode': 'single',
    'maxWidth': 'w-full',
    'wordWrapEnabled': true,
    'allowColumnResizing': false,
}
const gridMeta =  {
    'keyExpr': 'kodnaznpar',
    'columns': [
        {
            'name': 'kodnaznpar',
            'caption': 'kodnaznpar',
            'dataField': 'kodnaznpar',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kodnaznteplo',
            'caption': 'kodnaznteplo',
            'dataField': 'kodnaznteplo',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'v',
            'caption': 'Объем здания м³',
            'dataField': 'v',
            'allowEditing': true,
            'width': '33.3%',
            'dataType': 'number',
            'index': 3,
            'visible': true,
        },
        {
            'name': 'utx1',
            'caption': 'УТХ СО до 58 Ккал/м³˙час˙С',
            'dataField': 'utx1',
            'allowEditing': true,
            'width': '33.3%',
            'dataType': 'number',
            'index': 4,
            'visible': true,
        },
        {
            'name': 'utx2',
            'caption': 'УТХ СО п. 58 Ккал/м³˙час˙С',
            'dataField': 'utx2',
            'allowEditing': true,
            'width': '33.3%',
            'dataType': 'number',
            'index': 5,
            'visible': true,
        },

    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/ds-nazn-house-grid/select/get',
        'save': 'tep-nsi./tep-nsi/ds-nazn-house-grid/save/set',
    },
    'viewId': 'view-ds-nazn-house-grid',
    isFilterPanelVisible: false,
};
</script>
<style scoped>
.tep-tree__container {
    flex: 0 0 500px;
}
.tep-grid-name {
    width: 100%;
    text-align: center;
    padding: 10px 0;
}
.tep-header-item {
    align-items: center;
    gap: 4px;
}

.tep-header-label {
    width: 155px;
    text-align: right;
}
.tep-header_block {
    margin: 0 0 20px;
    padding: 0 0 20px;
    border-bottom: 1px solid  rgba(191, 191, 191, .7);;
}
</style>
